export enum ArrayMethodPlateRoleId {
  Source = 1,
  Destination = 2,
  Intermediate = 3,
  Dead = 4,
  Auxilliary = 5,
  Intermediate2 = 7,
}
